/* eslint-disable jsx-a11y/anchor-is-valid */

import { NavBar } from './styles/NavBar.styled';
import { Terms } from './styles/Terms.styled';
import { Footer } from './styles/Footer.styled';

const About = () => {
  return (
    <>
      <NavBar></NavBar>
      <main>
        <Terms>
          <div className="row">
            <h1>Privacy Notice</h1>
            <ul>
              <li>
                <h1>Purpose and Scope</h1>
                <p>
                  At Rade Integrated services ltd, we value the privacy of
                  individuals who share personal information with us. This
                  Privacy Notice explains:
                </p>
                <ul>
                  <li>
                    What personal information we collect from visitors, clients,
                    and third parties
                  </li>
                  <li>How we use and process that information</li>
                  <li>The legal basis for processing</li>
                  <li>With whom it may be shared</li>
                  <li>How it is stored and protected</li>
                </ul>
                <p>
                  This Notice applies to all visitors, clients, and third
                  parties (“you” and “your”) engaging with Rade Integrated
                  Services (“Rade,” “we,” “our”).
                </p>
              </li>
              <li>
                <h1>Information We Collect</h1>
                <p>We may collect the following personal information:</p>
                <ul>
                  <li>
                    Personal details: full name, proof of identification,
                    address, job title, vehicle license details
                  </li>
                  <li>
                    Employment details: employer name, address, contact
                    information
                  </li>
                  <li>
                    Security records: CCTV footage, biometric data (e.g.,
                    fingerprints for access systems), photographs for ID cards
                  </li>
                </ul>
                <p>
                  Sources: Information is usually obtained directly from you,
                  but may also come from third parties such as recruitment
                  agencies, government agencies, or your employer.
                </p>
              </li>
              <li>
                <h1>Use of Personal Information</h1>
                <p>
                  We use personal information for:
                  <ul>
                    <li>Registering visitors and issuing access cards</li>
                    <li>
                      Monitoring communications and internet usage for
                      compliance
                    </li>
                    <li>Health and safety management</li>
                    <li>Insurance and risk management</li>
                    <li>Compliance with laws and regulations</li>
                    <li>
                      Business operations including planning, auditing, and
                      accounting
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                <h1>Legal Basis</h1>
                <p>
                  We process personal information where necessary to comply with
                  legal obligations, contractual requirements, or legitimate
                  business interests.
                </p>
              </li>
              <li>
                <h1>Sharing Information</h1>
                <ul>
                  <li>
                    Within Rade Integrated services ltd: Information may be shared
                    internally for administrative, HR, IT, finance, and
                    operational purposes.
                  </li>
                  <li>
                    With third parties: Such as insurance providers, IT service
                    providers, auditors, regulators, and legal advisors.
                  </li>
                  <li>
                    Business transactions: If Rade Integrated services ltd undergoes
                    restructuring, sale, or acquisition, personal data may be
                    transferred as part of the process.
                  </li>
                </ul>
              </li>
              <li>
                <h1>Your Rights</h1>
                <p>
                  You have rights under data protection law, including the right
                  to:
                </p>
                <ul>
                  <li>Access the personal information we hold about you</li>
                  <li>Request updates or corrections</li>
                  <li>Restrict processing</li>
                </ul>
                <p>To exercise these rights, contact us at Rade Integrated services ltd contact email.</p>
              </li>
              <li>
                <h1>Retention</h1>
                <p>
                 We retain personal information only as long as necessary for business purposes or to comply with legal requirements.
                </p>
              </li>
              <li>
                <h1> Third‑Party Websites</h1>
                <p>
                  Our website may contain links to external sites. This Privacy Notice does not apply to those sites, and we are not responsible for their content or privacy practices.
                </p>
              </li>
              <li>
                <h1>Questions or Complaints</h1>
                <p>
                  If you have concerns about how we handle your personal information, please contact our Data Protection Team at Rade Integrated services ltd contact email. You may also escalate complaints to the relevant data protection authority.
                </p>
              </li>
            </ul>
          </div>
        </Terms>
      </main>
      <Footer></Footer>
    </>
  );
};

export default About;
